import Api from '@/services/Api'

export default {
    leaPaises(estado,desde,hasta){
        return Api().get('SleaPaises/'+estado+'/'+desde+'/'+hasta)
    },
    leaTodosPaises(){
        return Api().get('SleaTodosPaises')
    },
    leaFacturas(operacion,pais,estado,desde,hasta){
        return Api().get('SleaFacturas/'+operacion+'/'+pais+'/'+estado+'/'+desde+'/'+hasta)
    },
    leaFacturasCliente(pais,fecha_factura,estado,lider,usuario){
        return Api().get('SleaFacturasCliente/'+pais+'/'+fecha_factura+'/'+estado+'/'+lider+'/'+usuario)
    },
    informacionTodos(pais,desde,hasta){
        return Api().get('SinformacionTodos/'+pais+'/'+desde+'/'+hasta)
    },
    informacionConciliacion(pais,desde,hasta){
        return Api().get('SinformacionConciliacion/'+pais+'/'+desde+'/'+hasta)
    },

	conciliaDetalle(pais,desde,hasta,orden) {
		return Api().get('conciliaDetalle/'+pais+'/'+desde+'/'+hasta+'/'+orden)
	},

    informacionCruce(pais,desde,hasta){
        return Api().get('SinformacionCruce/'+pais+'/'+desde+'/'+hasta)
    },
    informacionCruceSinOrden(pais,desde,hasta){
        return Api().get('SinformacionCruceSinOrden/'+pais+'/'+desde+'/'+hasta)
    },
    informacionCruceRepSinOrden(pais,desde,hasta){

        return Api().get('SinformacionCruceRepSinOrden/'+pais+'/'+desde+'/'+hasta)
    },
    informacionReportados(pais,desde,hasta){
        return Api().get('SinformacionReportados/'+pais+'/'+desde+'/'+hasta)
    },
    informacionCruceReportados(pais,desde,hasta,idUsuario){
        return Api().get('SinformacionCruceReportados/'+pais+'/'+desde+'/'+hasta+'/'+idUsuario)
    },
    leaSeguimiento(factura,archivo){
        return Api().get('leaSeguimiento/'+factura+'/'+archivo)
    },
    leaEstadosSeg(estado){
        return Api().get('leaEstadosSeg/'+estado)
    },
    leaFacturasClienteEstado(pais,p_fecha_factura,estado,lider,usuario,desde,hasta){
        return Api().get('SleaFacturasClienteEstado/'+pais+'/'+p_fecha_factura+'/'+estado+'/'+lider+'/'+usuario+'/'+desde+'/'+hasta)
    },
    leaFacturasEstado(operacion,pais,desde,hasta){
        return Api().get('SLeaFacturasEstado/'+operacion+'/'+pais+'/'+desde+'/'+hasta)
    },
    segleaFacturasEstado(operacion,pais,desde,hasta){
        return Api().get('SLeaFacturasEstado/'+operacion+'/'+pais+'/'+desde+'/'+hasta)
    },
    anuleFacturas(fgl_anula,operacion,pais,desde,hasta){
        return Api().get('anuleFacturas/'+fgl_anula+'/'+operacion+'/'+pais+'/'+desde+'/'+hasta)
    },
    listeFacturasAnuladas(pais,desde,hasta){
        return Api().get('listeFacturasAnuladas/'+pais+'/'+desde+'/'+hasta)
    },
    leaFacturasAnulacion(fgl_anula,operacion,pais,desde,hasta,fecha_factura,fecha_solicitud,identificacion,documento_contable){
	let data={}
	data.fecha_factura=fecha_factura
	data.fecha_solicitud=fecha_solicitud
	data.identificacion=identificacion
	data.documento_contable=documento_contable
        return Api().put('leaFacturasAnulacion/'+fgl_anula+'/'+operacion+'/'+pais+'/'+desde+'/'+hasta,data)
    },
    grabeAnulacion(informacion){
        return Api().put('grabeAnulacion',informacion)
    },
    grabeContab(id,estado,r_seguimiento){
        return Api().put('SgrabeContab/'+id+'/'+estado,r_seguimiento)
    },
    leaAnulacionRegistrada(pais,factura,identificacion){
        return Api().get('leaAnulacionRegistrada/'+pais+'/'+factura+'/'+identificacion)
    },
}
